const projectEnvironment = process.env.REACT_APP_ENV_ENVIRONMENT;

// In local environments the localhost using port 3000 is the default selected signout/signin url.
const envRedirectSignIn = {
    dev: ["https://qa.d28v0cn1jy7oir.amplifyapp.com"],
    qa: ["https://qa.d28v0cn1jy7oir.amplifyapp.com"],
    prod: ["https://orgchart.eptarefrigeration.com"]
}
const envredirectSignOut = {
    dev: ["https://qa.d28v0cn1jy7oir.amplifyapp.com"],
    qa: ["https://qa.d28v0cn1jy7oir.amplifyapp.com"],
    prod: ["https://orgchart.eptarefrigeration.com"]
}

const envDomain = {
  dev: ["eu-central-1o3fbobols.auth.eu-central-1.amazoncognito.com"],
  qa: ["eu-central-1o3fbobols.auth.eu-central-1.amazoncognito.com"],
  prod: ["eu-central-1jmepjbff6.auth.eu-central-1.amazoncognito.com"]
}

const redirectSignIn = projectEnvironment ? envRedirectSignIn[projectEnvironment] : null;
const redirectSignOut = projectEnvironment ? envredirectSignOut[projectEnvironment] : null;
const domain = projectEnvironment ? envDomain[projectEnvironment] : null;

const customConfig = {
    "oauth": {
        "domain": domain ? domain : envDomain['dev'], // <-- By default, the dev environment is selected.
        "scope": [
            "email",
            "openid",
            "profile"
        ],
        "redirectSignIn": `http://localhost:3000,${redirectSignIn ? redirectSignIn.join(",") : ""}`,
        "redirectSignOut": `http://localhost:3000,${redirectSignOut ? redirectSignOut.join(",") : ""}`,
        "responseType": "code"
    },
};

console.log("this is the print of custom-config.js file in order to debug the redirect URIs: ", customConfig);

export default customConfig;